__turbopack_context__.v({
  "banner": "YgehaW_banner",
  "container": "YgehaW_container",
  "image": "YgehaW_image",
  "images": "YgehaW_images",
  "links": "YgehaW_links",
  "subHeader": "YgehaW_subHeader",
});
